import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";


Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "home",
            component: Home
        },
        {
            path: "/ravintoloille",
            name: "ravintoloille",
            component: () =>
                import(/* webpackChunkName: "about" */ "./views/Ravintoloille")
        },
        {
            path: "/ravintoloille.html", redirect: { name: "ravintoloille" },
        }
    ]
})

